module.exports = __webpack_public_path__ + "media/images/icon__live@2x-49292648775b1607c6092564a4c47788.png";